'use client';

import { Button, NavbarItem } from '@nextui-org/react';
import Link from 'next/link';
import { ROUTES } from '@/shared/routes/routes';
import { ShoppingCartIcon } from 'lucide-react';
import React from 'react';
import { useGetLocalStorageCartCountQuery } from '@/entities/cart/query';

export const CartLink = () => {
  const { data: cartCount } = useGetLocalStorageCartCountQuery();
  return (
    <NavbarItem className="px-0 hidden md:flex">
      <div className="relative flex items-start">
        <Link href={ROUTES.cart} aria-label="Корзина">
          <Button
            className="relative"
            isIconOnly
            radius="full"
            variant="light"
            aria-label="Корзина"
            title="Корзина"
          >
            {cartCount > 0 && (
              <span className=" absolute top-1 right-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary">
                {cartCount}
              </span>
            )}
            <ShoppingCartIcon size={24} strokeWidth={1.25} />
          </Button>
        </Link>
      </div>
    </NavbarItem>
  );
};
